import React                                from 'react';
import styled                               from 'styled-components';
import Th                                   from './components/Th';
import { IAcceptFilterData, makeAllFilter } from '../../utils';
import { theme }                            from 'theme';
import { apiTypes }                         from 'shared/consts/handbooksApiTypes';

interface IProps {
  config: any;
  sort: {
    field: string;
    direction: string;
  };
  onSortChange?: (field: string, direction: string) => void;
  onFilterChange?: (newFilter: string | { [x: string]: any[]; }[]) => void;
  connections?: {
    [key: string]: any[];
  };
  externalFilters?: any;
}

interface IState {
  showingFilterField?: string;
  allFilters: { [key: string]: IAcceptFilterData };
}

const SpreadTHead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 10;

  th {
    background-color: #eee;
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
    color: ${theme.colors.themePrimary};
  }
`;

class THead extends React.Component<IProps, IState> {
  state = {
    showingFilterField: undefined,
    allFilters: {} as { [key: string]: IAcceptFilterData },
  };

  onFilterShow = (fieldName?: string) => {
    this.setState({ showingFilterField: fieldName });
  };

  makeFilters = (): string => {
    return makeAllFilter(this.state.allFilters);
  };

  makeFiltersForReportApi = (): { [x: string]: any[]; }[] => {
    return Object.keys(this.state.allFilters).map((filterKey) => ({
      [filterKey]: this.state.allFilters[filterKey].selectedValues.map((value) => value.toString())
    }));
  }

  onFilterAccept = (filter: IAcceptFilterData) => {
    const filters = { ...this.state.allFilters };
    filters[filter.field.name] = filter;
    this.setState({ allFilters: filters }, () => {
      this.props.onFilterChange &&
        this.props.onFilterChange(this.props.config.apiType !== apiTypes.DEFAULT ? this.makeFiltersForReportApi() : this.makeFilters());
    });
  };

  render() {
    const { config, sort, connections } = this.props;
    const { allFilters } = this.state;
    return (
      <SpreadTHead>
        <tr>
          {config.fields.map(
            (el: any) =>
              !el.hide && (
                <Th
                  config={config}
                  key={`th-${el.name}`}
                  externalFilters={this.props.externalFilters}
                  field={{
                    title: el.title,
                    name: el.name,
                    type: el.type,
                    width: el.width,
                    connection: el.connection,
                    disableFilter: el.disableFilter,
                    disableSort: el.disableSort,
                    values: el.values,
                    required: el.required,
                  }}
                  sort={sort}
                  onSortChange={this.props.onSortChange}
                  onFilterShow={this.onFilterShow}
                  onFilterAccept={this.onFilterAccept}
                  allFilters={allFilters}
                  showFilter={this.state.showingFilterField === el.name}
                  connection={
                    el.connection && connections
                      ? {
                          config: config.connections[el.connection],
                          list: connections[el.connection] || [],
                        }
                      : undefined
                  }
                />
              )
          )}
        </tr>
        {config.fields.map(
            (el: any) => {
              if (el.innerColumns) {
                return (
                  <tr>
                    {
                      el.innerColumns.map((item: any) => {
                        return (
                          <Th
                            isInner
                            config={config}
                            key={`th-${item.key}`}
                            field={{
                              title: item.value,
                              name: item.key,
                              type: 'checkbox',
                              width: item.width,
                              connection: item.connection,
                              disableFilter: item.disableFilter,
                              disableSort: item.disableSort,
                              values: item.values
                            }}
                            sort={sort}
                            allFilters={allFilters}
                          />
                        )
                      })
                    }
                  </tr>
                )
              }

              return null;
            }
          )}
      </SpreadTHead>
    );
  }
}

export default THead;
